import { ActivityType, Countries } from "../../../enums";
import { TalentProfileApiService } from "../../talent-profile/talent-profile-api.service";
import { TalentHappyPathDataService } from "../service/talent-happy-path-data-service";

export const NOT_A_FIT = 'not-a-fit';

export function getJobBoardUrl(countryId: number) {
  switch (countryId) {
    case Countries.UK:
      return "https://aquent.co.uk/find-work";
    case Countries.FR:
      return "https://aquent.fr/find-work";
    case Countries.DE:
      return "https://aquent.de/find-work";
    case Countries.JP:
      return "https://aquent.co.jp/find-work";
    case Countries.AU:
      return "https://aquent.com.au/find-work";
    case Countries.NL:
      return "https://aquent.nl/find-work";
    default:
      return "https://aquent.com/find-work";
  }
}

export function sendDoThisLaterEmail(
  jobPostingId: number,
  personId: number,
  firstName: string,
  lastName: string,
  email: string,
  jobTitle: string,
  orderId: number,
  talentProfileService: TalentProfileApiService,
  isGeneralApplication: boolean
): void {
  talentProfileService.createTalentProfileActivity(
    ActivityType.TALENT_PROFILE_DO_THIS_LATER_CLICKED, personId, orderId, jobPostingId
  );
  const emailObservable = !isGeneralApplication
    ? talentProfileService.sendDoThisLaterEmail(
     jobPostingId, personId, firstName, lastName, email, jobTitle
    )
    : talentProfileService.sendGeneralApplicationDoThisLaterEmail(
     personId, firstName, lastName, email
    );

  emailObservable.subscribe(() => {
    console.log("Talent Do It Later Email sent successfully from Talent Profile.");
  }, error => {
    console.error("Error sending Talent Do It Later email from Talent Profile: ", error);
  });
}
